module.exports = __webpack_public_path__ + "static/media/hero-image.d3d980fc.svg";